import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../Components/Common/CustomButton";
import Loading from "../../Components/Common/Loading";
import InputText from "../../Components/sectioninput/formelement/InputText";
import { handleError } from "../../REDUX/actions/notifications";
import { updateCredentials, updateUser } from "../../REDUX/actions/users";

const AccountView = () => {
  const dispatch = useDispatch();

  const { userLoading, user } = useSelector((state) => state.usersReducer);

  const [formData, setuserForm] = useState(user);

  const [passwordConfirmation, setpasswordConfirmation] = useState("");
  const disableForm = !formData.username || !formData.lastName || !formData.firstName;
  const disableCredentials = !formData.email || !formData.newEmail || !formData.oldPassword || !formData.newPassword || !passwordConfirmation;

  useEffect(() => {
    setuserForm(user);
  }, [user]);

  const handleChangeForm = (value, champs) => {
    setuserForm({ ...formData, [champs]: value });
  };

  const handleChangePass = (value) => {
    setpasswordConfirmation(value);
  };

  const handleUpdateUser = () => {
    dispatch(updateUser(formData, user.id));
  };

  const handleUpdateCredentials = () => {
    if (passwordConfirmation !== formData.newPassword) {
      dispatch(handleError("Passwords do not match", 1)); // eslint-disable-next-line
    } else if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,9})+$/.test(formData.newEmail)) {
      dispatch(handleError("Invalid email address", 1));
    } else {
      dispatch(updateCredentials(formData, user.id));
    }
  };

  return !formData || userLoading ? (
    <Loading />
  ) : (
    <div className="container-fluid">
      <div className="row justify-content-center gap-5">
        <div className="col-6 bg-white rounded-10 shadowed p-5">
          <h2 className="mb-0 f24 fw-normal text-start mb-5">Edit Your Info</h2>
          <InputText labelinput="Username" handleChange={handleChangeForm} value={formData.username} champs="username" flag={false} hideIfEmpty={false} />
          <InputText labelinput="Last Name" handleChange={handleChangeForm} value={formData.lastName} champs="lastName" flag={false} hideIfEmpty={false} />
          <InputText labelinput="First Name" handleChange={handleChangeForm} value={formData.firstName} champs="firstName" flag={false} hideIfEmpty={false} />
          <div className="mt-5">
            <CustomButton buttonText="Edit Your Profile" iconStart={"pencil"} disabled={disableForm} callBack={handleUpdateUser} />
          </div>
        </div>

        <div className="col-5 bg-white rounded-10 shadowed p-5">
          <h2 className="mb-0 f24 fw-normal text-start mb-5">Edit Your Login Credentials</h2>

          <InputText labelinput="Old Email" handleChange={handleChangeForm} value={formData.email} champs="email" flag={false} hideIfEmpty={false} />
          <InputText labelinput="Old Password" type="password" handleChange={handleChangeForm} champs="oldPassword" flag={false} hideIfEmpty={false} />
          <InputText labelinput="New Email" handleChange={handleChangeForm} champs="newEmail" flag={false} hideIfEmpty={false} />
          <InputText labelinput="New Password" type="password" handleChange={handleChangeForm} champs="newPassword" flag={false} hideIfEmpty={false} />
          <InputText labelinput="Confirm New Password" type="password" handleChange={handleChangePass} champs="password" flag={false} hideIfEmpty={false} />
          <div className="mt-5">
            <CustomButton buttonText="Edit Your Login Credentials" iconStart={"pencil"} disabled={disableCredentials} callBack={handleUpdateCredentials} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountView;
